<template>
<div class="chapter">
<div class="inner_page">
<h2 class="pn"><a id="page_14"></a><a id="page_15"></a>Part One</h2>
<h2 class="pt">The First World War</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Part01.vue?0257319f